import React, { useContext } from "react";
import * as S from "./ChooseTestStyle";
import ButtonsGroup from "../ButtonsGroup/ButtonsGroup";
import { AppContext } from "../../AppContext";

const ChooseTest = (props) => {
  const { data, addIsImageTest } = useContext(AppContext);

  return (
    <S.Container>
      <S.BootstrapButtonGroup>
        <S.BootstrapButton
          color="primary"
          onClick={() => addIsImageTest(false)}
          active={!data.isImageTest}
        >
          Triplett-test
        </S.BootstrapButton>

        <S.BootstrapButton
          color="primary"
          onClick={() => addIsImageTest(true)}
          active={data.isImageTest}
        >
          Pilttest
        </S.BootstrapButton>
      </S.BootstrapButtonGroup>

      <ButtonsGroup
        onForwardBtnClick={props.onForwardBtnClick}
        onBackBtnClick={props.onBackBtnClick}
      />
    </S.Container>
  );
};

export default ChooseTest;
